if (!customElements.get('deployer-cart-drawer')) {
    customElements.define(
        'deployer-cart-drawer',
        class DeployerCartDrawer extends HTMLElement {
            constructor() {
                super();

                this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

                this.querySelector('#DeployerCartDrawer-Checkout').addEventListener('click', (event) => {
                    event.target.classList.add('deployer-button--is-loading');
                });

                // Connecte le panier à l'icône du panier
                this.setHeaderCartIconAccessibility();

                this.connectCartItemsListeners();
                
                // Marquer que le constructeur est terminé
                this.isConstructed = true;
            }

            connectedCallback() {
                // S'assurer que les formulaires sont attachés quand l'élément est ajouté au DOM
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', () => {
                        this.initializeProductForms();
                    });
                } else {
                    // DOM déjà chargé, initialiser après un court délai pour être sûr
                    setTimeout(() => {
                        this.initializeProductForms();
                    }, 100);
                }

                // Écouter les événements de chargement dynamique
                document.addEventListener('quickadd:loaded', () => {
                    this.setProductFormCompatibility(this);
                });
                document.addEventListener('ajaxProduct:added', async (event) => {
                    if (event.target !== document) return;
                    try {
                        const response = await fetch(`${window.Shopify.routes.root}?sections=${this.getSectionsToRender().map((section) => section.section).join(',')}`);
                        const sections = await response.json();
                        this.classList.remove('deployer-cart-drawer--empty');
                        this.renderCartContents({ sections });
                    } catch (error) {}
                });

                this.initProducts();
            }

            initProducts() {
                if (theme.QuickAdd) new theme.QuickAdd(this);
                this.querySelectorAll('[data-aos]').forEach((element) => element.classList.add('aos-init', 'aos-animate'));
                document.dispatchEvent(new CustomEvent('deployer-cart-drawer:updated'));
            }

            initializeProductForms() {
                // Connecte le panier aux formulaires des pages produit
                this.setProductFormCompatibility(this);
                
                // Réessayer après un délai si aucun formulaire n'a été trouvé
                const forms = document.querySelectorAll('form[action="/cart/add"]');
                if (forms.length === 0) {
                    setTimeout(() => {
                        this.setProductFormCompatibility(this);
                    }, 500);
                }
            }

            connectCartItemsListeners() {
                this.querySelector('.deployer-cart-drawer__overlay').addEventListener('click', this.close.bind(this));

                document.addEventListener('deployer-cart-drawer:refresh', () => {
                    this.refreshCart();
                });

                // Prévenir les conflits de scroll
                const cartBody = this.querySelector('.deployer-cart-drawer__body');
                if (cartBody) {
                    cartBody.addEventListener('scroll', (e) => {
                        // Empêcher la propagation du scroll vers le parent
                        e.stopPropagation();
                    }, { passive: true });
                }

                document.querySelectorAll('.deployer-cart-drawer__item').forEach((cart_item) => {
                    // Clic sur le bouton supprimer
                    const cart_item_remove_button = cart_item.querySelector('.deployer-cart-drawer__item-remove');
                    if (cart_item_remove_button) {
                        cart_item_remove_button.addEventListener('click', (event) => {
                            event.preventDefault();
                            this.updateLineItemQuantity(cart_item_remove_button.dataset.index, 0);
                        });
                    }

                    const cart_item_input = cart_item.querySelector('.deployer-cart-drawer__item-quantity-input');

                    // Mise à jour de l'input de quantité
                    if (cart_item_input) {
                        cart_item_input.addEventListener('change', () => {
                            this.updateLineItemQuantity(cart_item_input.dataset.index, cart_item_input.value);
                        });
                    }

                    // Clic sur les boutons de quantité
                    cart_item.querySelectorAll('.deployer-cart-drawer__item-quantity-button:not(.deployer-cart-drawer__item-quantity-button[disabled])').forEach((button) => {
                        button.addEventListener('click', (event) => {
                            const superiorElement = button.closest('.deployer-cart-drawer__item').querySelector('deployer-superior-offer');
                            if (superiorElement) {
                                superiorElement.handleClick(event);
                            } else {
                                this.onQuantityButtonClick(event, cart_item_input);
                            }
                        });
                    });
                });
            }

            setHeaderCartIconAccessibility() {
                if (window.deployerAdapter.cartIcon) {
                    window.deployerAdapter.cartIcon.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.open();
                    });
                } else {
                    console.error('Icône du panier non trouvée');
                }
            }

            // Intercepte les ajouts au panier pour les envoyer à la méthode de rendu du panier
            setProductFormCompatibility(cartDrawer) {
                // Détection iOS
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

                const forms = document.querySelectorAll('form[action*="/cart/add"]');
                
                // Log pour debug (peut être retiré en production)
                if (forms.length > 0) {
                    console.log(`✅ Deployer Cart Drawer: ${forms.length} formulaire(s) trouvé(s) et intercepté(s)`);
                }

                forms.forEach((form) => {
                    // Marquer le formulaire comme traité pour éviter les doublons
                    if (form.hasAttribute('data-deployer-cart-attached')) {
                        return;
                    }
                    form.setAttribute('data-deployer-cart-attached', 'true');

                    // Intercepter la soumission du formulaire (important pour iOS)
                    const formSubmitHandler = function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                    };
                    
                    form.addEventListener('submit', formSubmitHandler, { passive: false, capture: true });

                    form.querySelectorAll('[name="add"]').forEach((button) => {
                        // Supprimer les anciens event listeners s'ils existent
                        if (button.hasAttribute('data-deployer-click-attached')) {
                            return;
                        }
                        button.setAttribute('data-deployer-click-attached', 'true');

                        // IMPORTANT pour iOS : changer le type du bouton de "submit" à "button"
                        if (button.type === 'submit') {
                            button.type = 'button';
                        }

                        // Ajouter un style pour iOS
                        if (isIOS) {
                            button.style.cursor = 'pointer';
                            button.style.webkitTapHighlightColor = 'transparent';
                        }

                        let isProcessing = false;
                        
                        const clickHandler = function (event) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // Éviter les doubles appels (touchend + click sur iOS)
                            if (isProcessing || button.getAttribute('aria-disabled') === 'true' || button.disabled) return;
                            
                            isProcessing = true;
                            button.setAttribute('aria-disabled', true);
                            button.classList.add('deployer-button--is-loading');
                            // if (button.querySelector('.loading__spinner')) button.querySelector('.loading__spinner').classList.remove('hidden');

                            const config = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', Accept: `application/javascript` },
                            };
                            config.headers['X-Requested-With'] = 'XMLHttpRequest';
                            delete config.headers['Content-Type'];

                            const formData = new FormData(button.closest('form'));

                            formData.append(
                                'sections',
                                document
                                    .querySelector('deployer-cart-drawer')
                                    .getSectionsToRender()
                                    .map((section) => section.section)
                            );
                            formData.append('sections_url', window.location.pathname);

                            config.body = formData;

                            fetch('/cart/add', config)
                                .then((response) => response.json())
                                .then((response) => {
                                    if (response.status) {
                                        document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: response.description } }));
                                        return;
                                    }
                                    document.querySelector('deployer-cart-drawer').renderCartContents(response);
                                    document.dispatchEvent(new CustomEvent('cart-product:add'));
                                })
                                .catch((e) => {
                                    console.error(e);
                                    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: "Erreur d'ajout au panier" } }));
                                })
                                .finally(() => {
                                    // if (button.querySelector('.loading__spinner')) button.querySelector('.loading__spinner').classList.add('hidden');
                                    button.classList.remove('deployer-button--is-loading');
                                    button.removeAttribute('aria-disabled');
                                    if (cartDrawer.classList.contains('deployer-cart-drawer--empty')) cartDrawer.classList.remove('deployer-cart-drawer--empty');
                                    
                                    // Réinitialiser le flag après un délai pour permettre les futurs clics
                                    setTimeout(() => {
                                        isProcessing = false;
                                    }, 500);
                                });
                        };

                        // Pour iOS : gérer à la fois click et touchend
                        if (isIOS) {
                            // Sur iOS, gérer touchend qui est plus fiable que click
                            button.addEventListener('touchend', clickHandler, { passive: false, capture: true });
                            
                            // Empêcher touchstart de déclencher des actions par défaut
                            button.addEventListener('touchstart', function(e) {
                                e.stopPropagation();
                            }, { passive: false, capture: true });
                            
                            // Empêcher le double-tap zoom sur iOS
                            let lastTouchEnd = 0;
                            button.addEventListener('touchend', function(e) {
                                const now = Date.now();
                                if (now - lastTouchEnd <= 300) {
                                    e.preventDefault();
                                }
                                lastTouchEnd = now;
                            }, { passive: false });
                        }
                        
                        // Toujours garder le click pour les autres plateformes et comme fallback
                        button.addEventListener('click', clickHandler, { passive: false, capture: true });
                    });
                });
            }

            open() {
                // here the animation doesn't seem to always get triggered. A timeout seem to help
                setTimeout(() => {
                    this.classList.add('animate', 'active');
                });
                window.deployerAdapter.containerToAvoidScroll.classList.add(window.deployerAdapter.classToAvoidScroll);
            }

            close() {
                this.classList.remove('active');
                window.deployerAdapter.containerToAvoidScroll.classList.remove(window.deployerAdapter.classToAvoidScroll);
                if (window.deployerAdapter.containerToAvoidScroll.style.overflow === 'hidden') {
                    window.deployerAdapter.containerToAvoidScroll.style.overflow = 'auto';
                }
            }

            getSectionsToRender() {
                const cartContainerSectionId = window.deployerAdapter.cartIcon.closest('.shopify-section').id.replace('shopify-section-', '');
                return [
                    {
                        id: 'deployer-cart-drawer',
                        section: 'deployer-cart-drawer',
                        selector: '.deployer-cart-drawer__inner',
                    },
                    {
                        id: cartContainerSectionId,
                        section: cartContainerSectionId,
                        selector: window.deployerAdapter.cartIconSelector,
                    },
                ];
            }

            renderCartContents(parsedState) {
                // Sauvegarder la position de scroll actuelle
                const cartBody = this.querySelector('.deployer-cart-drawer__body');
                const scrollPosition = cartBody ? cartBody.scrollTop : 0;

                this.querySelector('.deployer-cart-drawer__inner').classList.contains('deployer-cart-drawer--empty') && this.querySelector('.deployer-cart-drawer__inner').classList.remove('deployer-cart-drawer--empty');

                this.getSectionsToRender().forEach((section) => {
                    const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                    const temporaryDom = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
                    if (temporaryDom.querySelector(section.selector)) {
                        sectionElement.innerHTML = temporaryDom.querySelector(section.selector).innerHTML;
                    } else {
                        sectionElement.innerHTML = temporaryDom.querySelector('.shopify-section').innerHTML;
                    }
                });

                setTimeout(() => {
                    this.open();
                    this.connectCartItemsListeners();
                    this.initProducts();
                    
                    // Restaurer la position de scroll
                    const newCartBody = this.querySelector('.deployer-cart-drawer__body');
                    if (newCartBody && scrollPosition > 0) {
                        newCartBody.scrollTop = scrollPosition;
                    }
                });
            }

            refreshCart() {
                // Sauvegarder la position de scroll actuelle
                const cartBody = this.querySelector('.deployer-cart-drawer__body');
                const scrollPosition = cartBody ? cartBody.scrollTop : 0;

                // Ne met pas à jour la pastille de l'icone du panier. Mise à jour à prévoir
                fetch(window.Shopify.routes.root + '?sections=deployer-cart-drawer')
                    .then((res) => res.json())
                    .then((data) => {
                        this.innerHTML = new DOMParser().parseFromString(data['deployer-cart-drawer'], 'text/html').querySelector('deployer-cart-drawer').innerHTML;
                        setTimeout(() => {
                            this.connectCartItemsListeners();
                            this.initProducts();
                            
                            // Restaurer la position de scroll
                            const newCartBody = this.querySelector('.deployer-cart-drawer__body');
                            if (newCartBody && scrollPosition > 0) {
                                newCartBody.scrollTop = scrollPosition;
                            }
                        });
                    });
            }

            onQuantityButtonClick(event, cart_item_input) {
                event.preventDefault();
                const previousValue = cart_item_input.value;

                event.target.name === 'plus' ? cart_item_input.stepUp() : cart_item_input.stepDown();
                if (previousValue !== cart_item_input.value) {
                    let timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        this.updateLineItemQuantity(cart_item_input.dataset.index, cart_item_input.value);
                    }, 300);
                }
            }

            updateLineItemQuantity(line, quantity) {
                this.enableLoading(line);

                const body = JSON.stringify({
                    line,
                    quantity,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: window.location.pathname,
                });

                fetch('/cart/change', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json` }, ...{ body } })
                    .then((response) => {
                        return response.text();
                    })
                    .then((state) => {
                        const parsedState = JSON.parse(state);
                        const quantityElement = document.getElementById(`DeployerCartDrawer-Quantity-${line}`);

                        if (parsedState.errors) {
                            quantityElement.value = quantityElement.getAttribute('value');
                            this.setLineItemError(line, parsedState.errors);
                            return;
                        }

                        document.dispatchEvent(new CustomEvent('cart-product:change'));

                        this.classList.toggle('deployer-cart-drawer--empty', parsedState.item_count === 0);

                        // Clear upsell upgrade flags when cart is empty
                        if (parsedState.item_count === 0) {
                            Object.keys(sessionStorage).forEach(key => {
                                if (key.startsWith('upsell_upgraded_')) {
                                    sessionStorage.removeItem(key);
                                }
                            });
                        }

                        this.renderCartContents(parsedState);
                    })
                    .catch((e) => {
                        console.error(e);
                        this.setCartError('Une erreur est survenue lors de l’actualisation de votre panier. Veuillez réessayer.');
                        this.disableLoading(line);
                    })
                    .finally(() => {
                        this.disableLoading(line);
                    });
            }

            setLineItemError(line, message) {
                if (document.querySelector('deployer-toast-notification')) {
                    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: message } }));
                    return;
                }
                const lineItemError = document.getElementById(`DeployerCartDrawer-LineItemError-${line}`);
                if (lineItemError) lineItemError.querySelector('.deployer-cart-drawer__item-error-text').innerHTML = message;
            }

            setCartError(message) {
                if (document.querySelector('deployer-toast-notification')) {
                    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: message } }));
                    return;
                }
                document.getElementById('DeployerCartDrawer-CartErrors').textContent = message;
            }

            enableLoading(line) {
                const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
                mainCartItems.classList.add('deployer-cart-drawer__items--disabled');
                const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
                cartDrawerItemElements.forEach((overlay) => overlay.classList.remove('hidden'));
                document.querySelector('.deployer-cart-drawer__totals-value')?.classList.add('deployer-loading');
                if (document.querySelector('.deployer-cart-drawer__reductions-value')) {
                    document.querySelector('.deployer-cart-drawer__reductions-value').classList.add('deployer-loading');
                }
                document.querySelector(`#DeployerCartDrawer-Item-${line} .deployer-cart-drawer__item-prices`).classList.add('deployer-loading');
            }

            disableLoading(line) {
                const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
                mainCartItems.classList.remove('deployer-cart-drawer__items--disabled');
                const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
                cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
                document.querySelector('.deployer-cart-drawer__totals-value')?.classList.remove('deployer-loading');
                if (document.querySelector('.deployer-cart-drawer__reductions-value')) {
                    document.querySelector('.deployer-cart-drawer__reductions-value').classList.remove('deployer-loading');
                }
                if (document.querySelector(`#DeployerCartDrawer-Item-${line}`)) {
                    document.querySelector(`#DeployerCartDrawer-Item-${line} .deployer-cart-drawer__item-prices`).classList.remove('deployer-loading');
                }
            }
        }
    );
}

class DeployerCartNote extends HTMLElement {
    constructor() {
        super();

        let inputTimeout;
        this.addEventListener('input', (event) => {
            clearTimeout(inputTimeout);
            inputTimeout = setTimeout(() => {
                const body = JSON.stringify({ note: event.target.value });
                fetch('/cart/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: body,
                });
            }, 300);
        });
    }
}

if (!customElements.get('deployer-cart-note')) customElements.define('deployer-cart-note', DeployerCartNote);

// Countdown timer

class DeployerCountdown extends HTMLElement {
    constructor() {
        super();
        this.countdownDuration = 0;
        this.redirectOnTimeout = false;
        this.countdownTimer = null;
        this.countdownEndTime = 0;
        this.countdownInterval = null;
    }

    connectedCallback() {
        this.countdownDuration = parseInt(this.dataset.duration) * 60;
        this.redirectOnTimeout = this.dataset.redirect === 'true';
        this.countdownTimer = this.querySelector('#countdown-timer');
        this.countdownEndTime = new Date().getTime() + this.countdownDuration * 1000;

        this.updateCountdown = this.updateCountdown.bind(this);
        this.countdownInterval = setInterval(this.updateCountdown, 1000);
        this.updateCountdown();
    }

    updateCountdown() {
        var now = new Date().getTime();
        var distance = this.countdownEndTime - now;
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
            clearInterval(this.countdownInterval);
            this.countdownTimer.innerHTML = "Le temps est écoulé.";
            if (this.redirectOnTimeout) {
                window.location.href = "/checkout";
            }
        } else {
            this.countdownTimer.innerHTML = minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
        }
    }
}

customElements.define('deployer-countdown', DeployerCountdown);

// Fallback global pour s'assurer que les formulaires sont interceptés
// Utile si le custom element n'est pas encore initialisé ou en cas de problème de timing
(function() {
    function ensureCartDrawerInit() {
        const cartDrawer = document.querySelector('deployer-cart-drawer');
        if (cartDrawer && typeof cartDrawer.setProductFormCompatibility === 'function') {
            cartDrawer.setProductFormCompatibility(cartDrawer);
        }
    }

    // Essayer à différents moments pour maximiser les chances
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ensureCartDrawerInit);
    } else {
        ensureCartDrawerInit();
    }
    
    // Fallback supplémentaire après le chargement complet
    window.addEventListener('load', () => {
        setTimeout(ensureCartDrawerInit, 100);
    });
})();


// Cross sells

class DeployerCartCrossSell extends HTMLElement {
    constructor() {
        super();
    }

    formatMoney(cents) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    }

    connectedCallback() {
        const layoutInline = JSON.parse(this.querySelector('.cross-sells-products').getAttribute('data-layout-inline'));

        if (layoutInline) {
            const elem = this.querySelector('.slider-layout');

            const observer = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.contentRect.width > 0) {
                        observer.unobserve(elem);
                        this.initFlickity(elem);
                    }
                }
            });

            observer.observe(elem);
        }

        this.querySelectorAll('.quick-add').forEach(button => {
            button.addEventListener('click', this.addToCart.bind(this));
        });

        // Gérer le changement d'options
        this.querySelectorAll('.cross-sell-option-select').forEach(select => {
            select.addEventListener('change', this.handleOptionChange.bind(this));
        });

        // Initialiser les variantes sélectionnées par défaut
        this.querySelectorAll('.cross-sell-variant-selector').forEach(selector => {
            this.updateSelectedVariant(selector);
        });
    }

    handleOptionChange(event) {
        const select = event.target;
        const variantSelector = select.closest('.cross-sell-variant-selector');
        this.updateSelectedVariant(variantSelector);
    }

    updateSelectedVariant(variantSelector) {
        const productContainer = variantSelector.closest('.cross-sell-product');
        const variants = JSON.parse(variantSelector.getAttribute('data-product-variants'));
        
        // Collecter toutes les options sélectionnées (sauf "Offer")
        const selectedOptions = {};
        variantSelector.querySelectorAll('.cross-sell-option-select').forEach(select => {
            const position = parseInt(select.getAttribute('data-option-position'));
            const value = select.value;
            selectedOptions[position] = value;
        });

        // Trouver la variante correspondante
        // Filtrer d'abord les variantes disponibles
        let availableVariants = variants.filter(variant => variant.available);
        
        // Si aucune variante disponible, utiliser toutes les variantes
        if (availableVariants.length === 0) {
            availableVariants = variants;
        }

        let matchedVariant = availableVariants.find(variant => {
            // Vérifier si toutes les options sélectionnées (visibles) correspondent
            for (let position in selectedOptions) {
                const optionIndex = parseInt(position) - 1; // Les positions commencent à 1
                if (variant.options[optionIndex] !== selectedOptions[position]) {
                    return false;
                }
            }
            return true;
        });

        // Si aucune variante exacte n'est trouvée, prendre la première variante disponible
        if (!matchedVariant && availableVariants.length > 0) {
            matchedVariant = availableVariants[0];
        }

        if (matchedVariant) {
            // Mettre à jour le prix
            const priceElement = productContainer.querySelector('.cross-sell-price');
            if (priceElement) {
                const formattedPrice = this.formatMoney(matchedVariant.price);
                priceElement.textContent = formattedPrice;
            }

            // Mettre à jour l'ID de variante du bouton
            const addButton = productContainer.querySelector('.quick-add');
            if (addButton) {
                addButton.setAttribute('data-product-id', matchedVariant.id);
                
                // Désactiver le bouton si la variante n'est pas disponible
                if (matchedVariant.available) {
                    addButton.removeAttribute('disabled');
                    addButton.style.opacity = '1';
                } else {
                    addButton.setAttribute('disabled', 'disabled');
                    addButton.style.opacity = '0.5';
                }
            }
        }
    }

    initFlickity(elem) {
        const flkty = new Flickity(elem, {
            cellAlign: 'left',
            contain: false,
            pageDots: false,
            percentPosition: true,
            draggable: true
        });

        flkty.resize();
    }

    addToCart(event) {
        const productId = event.target.getAttribute('data-product-id');
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: productId,
                quantity: 1
            })
        })
            .then(response => response.json())
            .then(() => {
                document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }
}

customElements.define('deployer-cart-cross-sell', DeployerCartCrossSell);


class DeployerSuperiorOffer extends HTMLElement {
    constructor() {
        super();

        this.superiorVariantId = this.dataset.superiorVariantId;
        this.currentVariantId = this.dataset.currentVariantId;
        this.lineItemKey = this.dataset.lineItemKey;
        this.lineItemQtn = this.dataset.lineItemQtn;
        this.button = this.querySelector('.btn');
    }

    connectedCallback() {
        if (this.button)
            this.button.addEventListener('click', this.handleClick.bind(this));
    }

    async handleClick(e) {
        e.preventDefault();

        if (this.superiorVariantId && this.currentVariantId && this.lineItemKey) {
            if (this.button.querySelector('.loading__spinner')) {
                this.button.classList.add('loading');
                this.button.querySelector('.loading__spinner').classList.remove('hidden');
            }
            try {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: this.lineItemKey,
                        quantity: this.lineItemQtn - 1
                    })
                });

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: this.superiorVariantId, quantity: 1 }]
                    })
                });

                document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));

            } catch (error) {
                console.error('Error upgrading variant:', error);
            }
        }
    }
}

customElements.define('deployer-superior-offer', DeployerSuperiorOffer);